import {
  faDownload,
  faFile,
  faFileExcel,
  faFilePdf,
  faFilePowerpoint,
  faFileWord,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'

import React from 'react'
import styles from './Document.module.css'

const DocumentParagraph = ({ fieldFile }) => {
  const file = fieldFile.entity.fieldFile.entity
  const description = fieldFile?.entity?.fieldFile?.description

  const renderIcon = () => {
    switch (file.filemime) {
      case 'application/pdf':
        return <FontAwesomeIcon icon={faFilePdf} color='red' />

      case 'application/vnd.ms-excel':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return <FontAwesomeIcon icon={faFileExcel} color='green' />

      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return <FontAwesomeIcon icon={faFileWord} color='blue' />

      case 'application/vnd.ms-powerpoint':
      case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        return <FontAwesomeIcon icon={faFilePowerpoint} color='orange' />

      default:
        return <FontAwesomeIcon icon={faFile} />
    }
  }

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  }

  return (
    <div className={styles.document}>
      <div className={styles.link}>
        <div className={styles.icon}>{renderIcon()}</div>
        <div className={styles.name}>{description || file.filename}</div>
      </div>
      <div className={styles.linkIcon}>
        <span className={styles.size}>{formatBytes(file.filesize)}</span>
        <a href={file.url} rel='noopener noreferrer' target='_blank' className={styles.icon}>
          <FontAwesomeIcon icon={faDownload} />
        </a>
      </div>
    </div>
  )
}

DocumentParagraph.propTypes = {
  media: PropTypes.shape({
    entity: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
    }),
  }),
}

const fragments = {
  paragraph: gql`
    fragment DocumentParagraphFragment on ParagraphDocument {
      id
      fieldFile {
        entity {
          ... on MediaDocument {
            fieldFile {
              entity {
                filename
                filemime
                filesize
                url
              }
              description
            }
          }
        }
      }
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { DocumentParagraph, fragments }
